import { Navigate, useParams } from "react-router-dom";

/**
 * As rotas antigas de Ajustes, que hoje são abas.
 *
 * Nove caminhos sob `configuracoes/*` nasceram como placeholder e
 * ficaram pra trás quando as abas viraram tela de verdade: quem tinha o
 * link salvo caía num stub descrevendo funcionalidade que já existe uma
 * URL ao lado. Nenhum link interno aponta pra eles (`navigation.ts` e
 * `AdminLayout` não os citam), então o único caminho até aqui é
 * favorito ou histórico do navegador — e a resposta certa pra isso é
 * levar até a aba, não explicar que ela existe.
 *
 * **`replace` pra não empilhar**: o botão de voltar deve sair da tela de
 * Ajustes, não devolver ao redirecionador e cair de novo no mesmo lugar.
 *
 * Mora em arquivo próprio, e não dentro da tabela de rotas, pra ser
 * testável sem importar o app inteiro — a tabela puxa toda tela do
 * sistema.
 */
export function LegacySettingsTab({ tab }: { tab: string }) {
  const { companyId } = useParams();
  return (
    <Navigate to={`/empresas/${companyId}/configuracoes?tab=${tab}`} replace />
  );
}
